import useTranslation from "../../../shared/hooks/useTranslation";
import { PriorityTypeCode } from "../models/models";

export const useCommonFormatters = () => {
  const { translate } = useTranslation(["myMachinery", "common"]);

  const priorityTypes = {
    [PriorityTypeCode.urgent]: {
      name: "myMachinery:priorities.urgent",
      description: "myMachinery:priorities.urgentDescription"
    },
    [PriorityTypeCode.high]: {
      name: "myMachinery:priorities.high",
      description: "myMachinery:priorities.highDescription"
    },
    [PriorityTypeCode.low]: {
      name: "myMachinery:priorities.low",
      description: "myMachinery:priorities.lowDescription"
    },
  };

  const formatPriorityTypeName = (code: PriorityTypeCode) => {
    return translate(priorityTypes[code].name);
  };

  const formatPriorityTypeDescription = (code: PriorityTypeCode) => {
    return translate(priorityTypes[code].description);
  };

  return {
    formatPriorityTypeName,
    formatPriorityTypeDescription,
  };
};
